import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Header from "./components/header/Header";
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import Testimonials from "./components/testimonials/Testimonials";
import DefaultConsent from "default-consent/DefaultConsent";
import WhatsAppButton from "./components/floating-whatsapp-button/FloatingWhatsAppButton";
import "./App.scss";
import Indications from "./components/indications/Indications";
import Service from "./components/services/Services";
import { ToastContainer } from "react-toastify";

const App = () => {
  const isMobile = window.innerWidth < 768; // breakpoint mobile

  useEffect(() => {
    AOS.init({
      disable: window.innerWidth < 768,
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="app">
      <ToastContainer
        position={isMobile ? "bottom-center" : "top-center"}
        autoClose={4000}
      />
      <Header />
      <main className="content">
        <About />
        <Service />
        <Indications />
        <Testimonials />
        <Contact />
      </main>
      <WhatsAppButton />
      <DefaultConsent />
    </div>
  );
};

export default App;
